const isBase64 = (image) => image.substr(0, 10) === 'data:image'

export default isBase64
